module.exports = __webpack_public_path__ + "img/logo_blanc_to_text.90c22639.png";